import { styled, theme } from "../../styles/stitches.config"

export const RAIL_HEIGHT = 8
export const SRail = styled("div", {
  width: "100%",
  height: RAIL_HEIGHT,
  backgroundColor: theme.colors.lines,
  cursor: "pointer",
  borderRadius: 4,
})

export const STrack = styled("div", {
  position: "absolute",
  top: 0,

  height: RAIL_HEIGHT,

  backgroundColor: theme.colors.successes,
  cursor: "pointer",
  borderRadius: 4,
  opacity: 0.7,
})

export const HANDLE_SIZE = 16
export const SHandle = styled("div", {
  position: "absolute",
  width: HANDLE_SIZE,
  height: HANDLE_SIZE,
  borderRadius: "50%",

  backgroundColor: theme.colors.successes,
  cursor: "pointer",
})

export const TICK_SIZE = RAIL_HEIGHT
export const STick = styled("div", {
  position: "absolute",
  top: 0,
  width: TICK_SIZE,
  height: TICK_SIZE,

  backgroundColor: theme.colors.textsAlt,
  borderRadius: "50%",
  cursor: "pointer",
})
